import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LenderToBorrowerListComponent } from './lender-to-borrower-list/lender-to-borrower-list.component';
import { BorrowerToLenderListComponent } from './borrower-to-lender-list/borrower-to-lender-list.component';

const routes: Routes = [
  { path: 'lender-to-borrower', component: LenderToBorrowerListComponent },
  { path: 'borrower-to-lender', component: BorrowerToLenderListComponent },
  { path: '', pathMatch: 'full', redirectTo: 'lender-to-borrower' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PickupsRoutingModule { }
